<script setup lang="ts">
import { computed } from 'vue';

import { parseAuraRichText } from '@/utils/auraRichText';

const props = defineProps<{
    text: string;
}>();

const lines = computed(() => parseAuraRichText(props.text));
</script>

<template>
    <div class="space-y-1 whitespace-pre-wrap">
        <p v-for="(line, lineIndex) in lines" :key="lineIndex">
            <span v-if="line.isBullet" class="mr-1" aria-hidden="true">•</span>
            <template v-for="(token, tokenIndex) in line.tokens" :key="tokenIndex">
                <strong v-if="token.type === 'strong'">{{ token.content }}</strong>
                <a
                    v-else-if="token.type === 'link'"
                    :href="token.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-[#48DDC3] underline hover:text-[#3bc4ab]"
                >
                    {{ token.content }}
                </a>
                <template v-else>{{ token.content }}</template>
            </template>
        </p>
    </div>
</template>
